import { type FormInstance } from "antd"

export const validateFormWithScroll = async <T = any,>(
  form: FormInstance<T>
): Promise<T> => {
  try {
    return await form.validateFields()
  } catch (error: any) {
    const firstErrorField = error.errorFields?.[0]?.name?.[0]

    if (firstErrorField) {
      form.scrollToField(firstErrorField, {
        behavior: "smooth",
        block: "center",
        inline: "center"
      })
    }

    throw error
  }
}
